<div
  role="status"
  [attr.aria-label]="'account_orders.loading' | translate"
>
  <div aria-hidden="true">
    <div class="skeleton-heading">{{ 'global.my_orders' | translate }}</div>
    <div class="skeleton-toolbar">
      <div class="g-placeholder-item skeleton-label"></div>
      <div class="skeleton-search">
        <div class="g-placeholder-item skeleton-input"></div>
        <div class="g-placeholder-item skeleton-button"></div>
      </div>
    </div>
    @for (i of [1, 2, 3]; track i) {
      <div class="skeleton-card">
        <div class="skeleton-header">
          <div>
            <div class="g-placeholder-item skeleton-number"></div>
            <div class="g-placeholder-item skeleton-date"></div>
          </div>
          <div class="g-placeholder-item skeleton-status"></div>
          <div class="g-placeholder-item skeleton-total"></div>
        </div>
        <div class="skeleton-products">
          <div class="skeleton-images">
            @for (j of [1, 2, 3]; track j) {
              <div class="g-placeholder-item skeleton-image"></div>
            }
          </div>
          <div>
            <div class="g-placeholder-item skeleton-number"></div>
            <div class="g-placeholder-item skeleton-description"></div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
